import { render, staticRenderFns } from "./PointLeaderboard.vue?vue&type=template&id=ee17fc36"
import script from "./PointLeaderboard.vue?vue&type=script&lang=js"
export * from "./PointLeaderboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports